module.exports = __webpack_public_path__ + "media/ok-button.d81182c9.mp3";